export default "__VITE_ASSET__CWbw0_p0__"